/**
 * fusionMsiRoleSplashRoutes.jsx — /for/* on the fusionmsi host.
 * Shaped by prompts 35 and 38; MKT-01, MKT-08, MKT-20, MKT-23, MKT-25.
 * Invariants: a role page never grants access. /for/patient redirects to
 * /caremap2. Unknown and unpublished /for/:roleSlug use the existing unmatched
 * fallback so they cannot match the geo /:country route. Nothing is published.
 * Related: AppRoutes.jsx, RolePageRoute.jsx, docs/marketing/ROLE_SPLASH_PAGE_REGISTER.md
 */
import React from "react";
import { Navigate, Route } from "react-router-dom";
import RolePageRoute from "features/decisionPoint/pages/RolePageRoute";

export function fusionMsiRoleSplashRouteElements(unmatchedElement) {
  return (
    <>
      <Route path="/for/patient" element={<Navigate to="/caremap2" replace />} />
      <Route
        path="/for/:roleSlug"
        element={<RolePageRoute unmatchedElement={unmatchedElement} />}
      />
    </>
  );
}
